module.exports = __webpack_public_path__ + "static/hiddenMarket-c246349e406aef0fb4f40b6ddeb733d0.png";